/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'


import { render, staticRenderFns } from "./payment.vue.js?vue&type=template&id=2d72df1a!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment.vue?vue&type=template&id=2d72df1a"
import script from "./payment.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment.vue?vue&type=script&setup=true&lang=js"
export * from "./payment.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./payment.vue.postcss?vue&type=style&index=0&id=2d72df1a&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payment.vue?vue&type=style&index=0&id=2d72df1a&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanButton})
